import React, { CSSProperties, useMemo } from 'react';
import { useLocation } from 'react-router';
import { getFallbackImage } from './utility/get-fallback-image';
import { Page } from '@shopify/polaris';

type Props = CSSProperties;

const DefaultImageSkeleton: React.FC<Props> = (style) => {
    const location = useLocation();

    const fallbackImage = useMemo(() => getFallbackImage(location.pathname), [location.pathname]);

    return (
        <Page fullWidth={fallbackImage.fullWidth}>
            <img style={{ maxWidth: '100%' }} src={fallbackImage.src} alt="main skeleton" />
        </Page>
    );
};

export default DefaultImageSkeleton;
